module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng4.d6a15c74.png";